import content from "app-content";
import formatPrice from "../../formatPrice";

const getOptionText = ({ size, price, isVariantInStock }) =>
  `${size}${price ? ` ${formatPrice(price.current.value)}` : ""}${
    !isVariantInStock ? ` - ${content.saved_items_item_product_oos}` : ""
  }`;

export default getOptionText;
